var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#CED7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.33334C8.31331 5.33334 5.33331 8.31334 5.33331 12C5.33331 15.6867 8.31331 18.6667 12 18.6667C15.6866 18.6667 18.6666 15.6867 18.6666 12C18.6666 8.31334 15.6866 5.33334 12 5.33334ZM12 17.3333C9.05998 17.3333 6.66665 14.94 6.66665 12C6.66665 9.06001 9.05998 6.66668 12 6.66668C14.94 6.66668 17.3333 9.06001 17.3333 12C17.3333 14.94 14.94 17.3333 12 17.3333ZM14.3933 8.66668L12 11.06L9.60665 8.66668L8.66665 9.60668L11.06 12L8.66665 14.3933L9.60665 15.3333L12 12.94L14.3933 15.3333L15.3333 14.3933L12.94 12L15.3333 9.60668L14.3933 8.66668Z",
    fill: "#FBFBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.434fe8666cbd5a5ffa85115db40e884e.svg";
export { ForwardRef as ReactComponent };